import { createLucideIcon } from 'lucide-react';

const TreeUpDownRightIcon = createLucideIcon('TreeUpDownRight', [
  [
    'path',
    {
      d: 'M4 2V9C4 10.061 4.421 11.078 5.172 11.828 5.922 12.579 6.939 13 8 13H20M4 2V22',
      key: '1',
    },
  ],
]);

TreeUpDownRightIcon.displayName = 'TreeUpDownRightIcon';

export default TreeUpDownRightIcon;
